import React from "react";

interface Props {}

export const Page403: React.FC<Props> = () => {
  return <div>403</div>;
};

export default Page403;
